( function( ) {
	var button = $('button#btn-avisos'),
		avisos = $('div.aviso__message');
	var sumaavisostot = $('.aviso-clases').length;
	var sumaavisos = $('.aviso-clases').length;

	button.on('click', function(e){
		e.preventDefault();
		if(sumaavisos >= 0)
		{
		avisos.slideToggle(300);
		$('.aviso-clases,.cerraraviso').stop().fadeIn(800);
		} else {
		sumaavisos = sumaavisostot;
		}
	});

	$('.cerraraviso').on('click', function(event){
		event.preventDefault();
		var idaviso = $(this).data('avisoid');
		$('#cont_aviso_'+idaviso).slideToggle(300);
		$(this).hide();
		sumaavisos--;
		console.log(sumaavisos);
	});

	// Execute Panels Height
	setTimeout(getheight, 2500);
	function getheight() {
		var panels = $('div.panel');
		panels.matchHeight();
	};
	// Modal para detalle de citas
	var otroModal = $("#events-modal");
	otroModal.on("show.bs.modal", function(e) {
	    var link = $(e.relatedTarget);
	    $(this).find(".modal-content").load(link.data("href"));
	});

	// Modal de Contacto
	var ModalContacto = $("#modalContacto");
	ModalContacto.on("show.bs.modal", function(e) {
	    var link = $(e.relatedTarget);
	    $(this).find(".modal-content").load(link.data("href"));
	});
	ModalContacto.on('hide.bs.modal', function(e) {
		var link = $(e.relatedTarget);
	    $(this).find(".modal-content").html('');
	});

	function generarBotonesParaEliminar() {
		var elimina = $('a.deleteElement');

		// Confirmation to delete a record
		$.ajaxSetup({
	        headers: {
	            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	        }
	    });
		elimina.on('click', function(e) {
			e.preventDefault();
			var value = $(this),
				urls = value.data('url');
			swal({
				title: '<h2>Está seguro?</h2>',
				text: '<span style="color: red;">Está a punto de eliminar el registro. La información no podrá ser recuperada. ESTA ACCION NO SE PUEDE DESHACER.</span>',
				type: "warning",
				html: true,
				showCancelButton: true,
				confirmButtonColor: "#DD6B55",
				confirmButtonText: "Si, Continuar!",
				cancelButtonText: "No, cancelar!",
				closeOnConfirm: false,
				closeOnCancel: false,
				showLoaderOnConfirm: true,
			}, function(isConfirm){
				if (isConfirm) {
					$.ajax({
			            url: urls,
			            type:"POST",
			            data: {id: value.data('id'), _token: value.attr('data-token')}
			        })
		            .done(function(data){
		            	if(data == 1) {
			            	swal({
			            		title: "Eliminado!",
			            		text: "El Registro se ha enviado a la Papelera de Reciclaje",
			            		type: "success"
			            	}, function(){
			            		window.location.reload(true);
			            	});
		            	} else {
		            		swal({
			            		title: "Uppss",
			            		text: "El Registro no pudo ser enviado a la Papelera de Reciclaje",
			            		type: "error"
			            	}, function(){
			            		window.location.reload(true);
			            	});
		            	}
		            });
				} else {
					swal( {
						title: '<h2>Cancelado</h2>',
			            text: '<p>La solicitud ha sido cancelada</p>',
			            type: 'error',
			            html: true,
					});
				}
			});
		});
	};

	generarBotonesParaEliminar();

	$('[data-toggle=offcanvas]').click(function() {
  	$(this).toggleClass('visible-xs text-center');
    $(this).find('i').toggleClass('fa-chevron-right fa-chevron-left');
    $('.row-offcanvas').toggleClass('active');
    $('.lg-menu').toggleClass('hidden-xs').toggleClass('visible-xs');
    $('.xs-menu').toggleClass('visible-xs').toggleClass('hidden-xs');
    $('#btnShow').toggle();
});

}) ( );
